
// eslint-disable-next-line 
import { ProfessionalModel } from "@/domain/models";
import { professionalService } from "@/domain/services";
import { defineComponent } from "vue";
import { mapState, mapActions } from "vuex";

export default defineComponent({
  name: "ProfessionalList",
  computed: {
    ...mapState("professionals", ["professionals", "isLoading"]),
  },
  created() {
    this.loadProfessionals();
  },
  methods: {
    deleteProfessional(id: number) {
      if (confirm("Você realmente deseja deletar essa clínica?")) {
        professionalService.deleteById(id).then(() => {
          this.loadProfessionals();
        });
      }
    },
    ...mapActions({ loadProfessionals: "professionals/load" }),
  },
});
